import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { openSmallConfirmDialog } from '@app/modules/ui-notification/smallConfirmDialog/confirmDialog.component';
import { Licence } from '@core/auth/guards/license.guard';
import { UserService } from '@core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { map, of, switchMap } from 'rxjs';

export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const _userService = inject(UserService)
    const _matDialog = inject(MatDialog)

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${encodeURIComponent(state.url)}`;
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }
                return _userService.user$.pipe(map(u => {
                    console.log("Checking", u);
                    if (u.accessLevel < Licence.CorporatingsAdmin) {
                        router.navigate(['/'], { queryParams: { redirectURL: redirectURL } }).then(
                            (navigated: boolean) => {
                                openSmallConfirmDialog(_matDialog, "Forbidden", "You are NOT allowed to access the admin interface of LENS", "OK")
                            }
                        );
                    }
                    return u.accessLevel == Licence.CorporatingsAdmin
                }))
            }),
        )
        ;
};
